
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Punetonashiktrimbkeshwercabs() {



    const cardData =
    {
        keyword: 'Pune To Nashik Trimbakeshwar Cabs',
        heading: 'Morya Cabs:  Pune To Nashik Trimbakeshwar Cabs',
        headingDescription: 'Morya Cabs offers reliable and comfortable Pune to Nashik Trimbakeshwar cab services to make your spiritual journey smooth and stress-free. Whether you are planning a religious pilgrimage, family trip, or solo darshan, our well-maintained cabs and courteous drivers ensure a safe and pleasant ride. With on-time pickups, clean vehicles, and flexible booking options, Morya Cabs is your trusted travel partner for visiting the sacred Trimbakeshwar Jyotirlinga from Pune.',

        top: 'Top Places to Visit in Trimbakeshwar with Morya Cabs',

      "topPlaces": [
    {
        "title": "Brahmagiri Hill",
        "description": "Brahmagiri Hill is the origin of the sacred Godavari River and a major spiritual destination. The trek involves around 750 steps and offers panoramic views of the surrounding hills, along with sacred spots like Ganga Dwar and Ram Kund."
    },
    {
        "title": "Anjaneri Fort",
        "description": "Located about 7 km from Trimbakeshwar, Anjaneri is believed to be the birthplace of Lord Hanuman. It's a popular trekking spot known for its scenic trails, caves, and religious significance."
    },
    {
        "title": "Harihar Fort",
        "description": "About 13 km from Trimbak, Harihar Fort is famous for its steep rock-cut steps that seem almost vertical. It's a thrilling trek that rewards you with breathtaking views from the top."
    },
    {
        "title": "Dugarwadi Waterfall",
        "description": "Located around 12 km from Trimbakeshwar, Dugarwadi is a serene, seasonal waterfall surrounded by lush greenery. It’s especially beautiful during monsoon, making it perfect for nature lovers."
    },
    {
        "title": "Gangadwar",
        "description": "Gangadwar is located on the Brahmagiri Hill and is the exact spot where the Godavari River is believed to emerge. It’s a revered site for Hindu pilgrims and a peaceful spiritual location."
    },
    {
        "title": "Trimbakeshwar Market",
        "description": "Just outside the temple area, the local market offers religious items, rudraksha malas, and local sweets. It’s a great place to explore for cultural shopping and local vibes."
    },
    {
        "title": "Kushavart Kund",
        "description": "Kushavart Kund is the symbolic origin of the Godavari River. It’s a sacred bathing ghat where pilgrims perform rituals and take holy dips before visiting the Trimbakeshwar Temple."
    },
    {
        "title": "Coin Museum",
        "description": "Located around 3 km from Trimbakeshwar, the Indian Institute of Research in Numismatic Studies offers a unique display of ancient coins, making it an educational stop for history buffs."
    },
    {
        "title": "Goraknath Gufa",
        "description": "This ancient cave near Brahmagiri Hill is associated with the sage Gorakhnath. It is a quiet and peaceful place ideal for meditation and spiritual reflection."
    },
    {
        "title": "Gautami Ganga Dam",
        "description": "Also known as Trimbak Dam, this serene location is ideal for a peaceful escape from crowds. Surrounded by hills and lush forests, it's a nice picnic spot near the temple town."
    }
],

"services": [
    {
        "name": "Pune to Nashik Trimbakeshwar Cabs",
        "description": "Morya Cab offers reliable and affordable cab services from Pune to Nashik Trimbakeshwar, perfect for solo travelers, families, or groups heading for pilgrimage or sightseeing. Enjoy a stress-free journey in our clean, well-maintained cabs with experienced drivers who know the route and terrain well. Your spiritual journey begins the moment you book with Morya Cab."
    },
    {
        "name": "Nashik Trimbakeshwar Darshan Cab from Pune",
        "description": "Book a specialized darshan cab from Pune to Trimbakeshwar with Morya Cab for a peaceful and timely visit to one of India’s 12 Jyotirlingas. Our drivers are well-versed in the temple schedule and darshan timings, helping you plan your religious trip without hassle. Choose our comfortable vehicles for an enriching and serene temple visit."
    },
    {
        "name": "Pune to Trimbak Taxi Booking",
        "description": "Easily book your cab from Pune to Trimbak online or via phone with Morya Cab. Our seamless booking system ensures instant confirmations, transparent pricing, and flexible options for one-way, round-trip, or multi-day journeys. Whether it’s a spontaneous trip or a planned pilgrimage, we have you covered with reliable transport and top-rated service."
    },
    {
        "name": "One-Way Cab Pune to Nashik Trimbakeshwar",
        "description": "If you're looking for a one-way cab from Pune to Trimbakeshwar, Morya Cab provides affordable options with no return fare obligations. Ideal for those heading to Nashik or further, our one-way services offer full comfort, timely pickups, and experienced drivers who prioritize your safety and satisfaction."
    },
    {
        "name": "Round Trip Cabs Pune to Trimbakeshwar",
        "description": "Planning to return the same day or the next? Choose Morya Cab’s round-trip taxi services from Pune to Trimbakeshwar for flexible timing and great value. Our round-trip cabs are perfect for temple visits, sightseeing, or family trips, offering consistent quality and courteous drivers at your service throughout the journey."
    },
    {
        "name": "AC Taxi Pune to Trimbakeshwar",
        "description": "Beat the heat and travel in comfort with our air-conditioned taxis from Pune to Trimbakeshwar. Morya Cab ensures a relaxed and enjoyable ride, even during the summer months. Our fleet includes modern AC sedans and SUVs, perfect for small or large groups seeking a cooler and smoother ride."
    },
    {
        "name": "Nashik Temple Tour Cab from Pune",
        "description": "Explore Nashik’s famous spiritual landmarks with Morya Cab’s Temple Tour packages from Pune. Visit Trimbakeshwar, Kalaram Temple, and more, all in one well-planned trip. Our knowledgeable drivers assist you in covering all major temples comfortably and on time, making it a complete spiritual journey."
    },
    {
        "name": "Religious Trip Pune to Trimbakeshwar",
        "description": "Make your spiritual journey to Trimbakeshwar from Pune seamless and fulfilling with Morya Cab. We offer specially curated religious travel experiences for individuals, families, and elder pilgrims, with early morning pickups, temple guidance, and return options—all with utmost respect to your spiritual schedule."
    },
    {
        "name": "Pune to Nashik Trimbak Cab with Driver",
        "description": "Hire a chauffeur-driven cab from Pune to Nashik Trimbak and experience professional, punctual, and friendly service throughout. Our drivers are trained for long-distance travel and understand the route's religious significance. Sit back and enjoy your trip while we take care of the driving and navigation."
    },
    {
        "name": "Affordable Pune to Trimbakeshwar Taxi",
        "description": "Looking for a cost-effective yet comfortable ride to Trimbakeshwar? Morya Cab offers budget-friendly taxis from Pune without compromising on quality or safety. Our transparent pricing policy, fuel-inclusive fares, and no hidden charges make us a top choice for religious travelers and budget-conscious tourists."
    },
    {
        "name": "Private Cabs Pune to Nashik",
        "description": "For those who value privacy and personalized service, Morya Cab offers private cabs from Pune to Nashik and Trimbakeshwar. Whether it’s a solo journey, a couple’s trip, or a small family tour, enjoy exclusive use of a sanitized, spacious vehicle with full comfort, convenience, and confidentiality."
    },
    {
        "name": "Sedan Cabs Pune to Trimbakeshwar",
        "description": "Travel in style and comfort with Morya Cab’s sedan services from Pune to Trimbakeshwar. Our sedans are ideal for 2-4 passengers, offering ample legroom, luggage space, and air-conditioned interiors. Enjoy a smooth ride whether you're traveling for spiritual reasons or leisure."
    },
    {
        "name": "Pune to Trimbakeshwar Darshan Cab",
        "description": "Book a darshan cab to Trimbakeshwar from Pune with Morya Cab and ensure a peaceful, comfortable, and timely temple visit. We offer early morning pickups, darshan coordination, and drop-back services tailored to your pilgrimage requirements, all handled by courteous and experienced drivers."
    },
    {
        "name": "Family Taxi Pune to Nashik Trimbak",
        "description": "Planning a family pilgrimage or weekend getaway? Our family-friendly taxis from Pune to Nashik Trimbak are spacious, secure, and equipped with amenities for all ages. Morya Cab focuses on safety, comfort, and flexibility to meet your family's travel needs with ease."
    },
    {
        "name": "Safe Pilgrimage Cab Pune to Trimbakeshwar",
        "description": "Your safety and peace of mind are our top priorities. Morya Cab offers secure and reliable pilgrimage taxi services from Pune to Trimbakeshwar. All vehicles are sanitized, GPS-tracked, and driven by verified professionals trained to handle pilgrim-specific needs like temple timing, special stops, and respectful communication."
    }
],

"tableData": [
    ["Pune to Nashik Trimbakeshwar Cabs", "-Nashik Trimbakeshwar Darshan Cab from Pune"],
    ["Pune to Trimbak Taxi Booking", "-One-Way Cab Pune to Nashik Trimbakeshwar"],
    ["Round Trip Cabs Pune to Trimbakeshwar", "-AC Taxi Pune to Trimbakeshwar"],
    ["Nashik Temple Tour Cab from Pune", "-Religious Trip Pune to Trimbakeshwar"],
    ["Pune to Nashik Trimbak Cab with Driver", "-Affordable Pune to Trimbakeshwar Taxi"],
    ["Private Cabs Pune to Nashik", "-Sedan Cabs Pune to Trimbakeshwar"],
    ["Pune to Trimbakeshwar Darshan Cab", "-Family Taxi Pune to Nashik Trimbak"],
    ["Safe Pilgrimage Cab Pune to Trimbakeshwar", "-Call Morya Cab at +91 9371304510"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab ensures punctual pickups and drop-offs for your Pune to Nashik Trimbakeshwar journey. Whether it's a spiritual visit or a family trip, we prioritize your time and provide dependable service every step of the way."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel in comfort with our clean, spacious, and air-conditioned cabs. Our vehicles are ideal for long-distance travel, making your Pune to Trimbakeshwar journey relaxing, whether you're traveling solo or in a group."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced in long-distance and pilgrimage routes. They are well-versed with the Pune to Trimbakeshwar roadways and ensure a smooth, safe, and respectful journey to this sacred destination."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Morya Cab, you enjoy fair and competitive rates for your Pune to Nashik Trimbakeshwar trip. No hidden charges—just honest, upfront pricing for a worry-free travel experience."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. Our cabs are equipped with essential safety features and undergo regular maintenance. Our drivers adhere to traffic rules, ensuring a secure and smooth pilgrimage journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Planning an early morning darshan or a late-night return? Morya Cab operates round-the-clock to match your schedule and spiritual commitments, with full customer support whenever you need it."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your Pune to Trimbakeshwar cab is quick and simple. Use our website, mobile app, or call our friendly support team to reserve your cab effortlessly and receive instant confirmation."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer flexible and personalized travel packages for your Nashik Trimbakeshwar trip. Whether you want temple visits, sightseeing stops, or overnight stays, Morya Cab will tailor the experience to your needs."
    }
]














    }

  const faqData = [
  {
    question: "How can I book a Pune to Nashik Trimbakeshwar cab with Morya Cab?",
    answer: "Booking is quick and easy! You can reserve your cab through our website, mobile app, or by contacting our customer support team for assistance."
  },
  {
    question: "Are the drivers familiar with the route to Trimbakeshwar from Pune?",
    answer: "Yes, our drivers are well-versed with the Pune to Nashik and Trimbakeshwar route, ensuring a safe, smooth, and comfortable journey."
  },
  {
    question: "What vehicle options are available for this route?",
    answer: "We offer a variety of vehicles including sedans, SUVs, and luxury cars to suit your travel needs and group size, all well-maintained and comfortable."
  },
  {
    question: "Can I plan a same-day return trip to Trimbakeshwar?",
    answer: "Absolutely! We offer flexible one-way and round-trip options. Just mention your return time while booking, and we'll plan accordingly."
  },
  {
    question: "Do you offer temple visits and sightseeing at Trimbakeshwar?",
    answer: "Yes, our cabs can be booked for temple darshan and local sightseeing in Trimbakeshwar. Let us know your itinerary and we'll customize the trip."
  },
  {
    question: "What are the payment options available?",
    answer: "We accept cash, credit/debit cards, and online payments via our app or website for your convenience."
  },
  {
    question: "Is the fare fixed or are there extra charges?",
    answer: "Our fares are transparent with no hidden charges. Any extra cost for waiting or detours will be clearly communicated in advance."
  },
  {
    question: "Can I travel at night from Pune to Trimbakeshwar?",
    answer: "Yes, we offer 24/7 cab services. You can travel at your preferred time, and our drivers are trained for safe night driving as well."
  },
  {
    question: "Is the trip suitable for senior citizens or families?",
    answer: "Definitely. Our drivers are courteous and our vehicles are comfortable and reliable, making them ideal for senior citizens and family trips."
  },
  {
    question: "Why choose Morya Cab for Pune to Trimbakeshwar travel?",
    answer: "Morya Cab is known for its punctuality, reliability, and courteous service. We ensure a stress-free pilgrimage and travel experience for all our customers."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Sanjay Deshmukh',
    role: 'Pilgrim Traveler',
    review: 'I booked Morya Cab for a family trip to Trimbakeshwar from Pune. The driver was respectful and punctual, and the car was clean and comfortable. We had a peaceful darshan without any stress.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Neha Patil',
    role: 'Spiritual Seeker',
    review: 'Traveling to Trimbakeshwar with Morya Cab was a great experience. The team was professional, and they made sure we had enough time for darshan and sightseeing. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];

      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
   
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Trimbakeshwar Cabs",
  "image": "https://moryacab.com/assets/images/pune-to-nashik-trimbakeshwar-cabs.jpg",
  "description": "Book Pune to Nashik Trimbakeshwar cab service with Morya Cab. Enjoy safe, reliable, and affordable rides with clean AC Sedan, SUV, Innova Crysta, and Tempo Traveller options. Ideal for family trips, pilgrimages, and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7124"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/pune-to-nashik-trimbakeshwar-cabs"
  }
};







    return (
        <div>
            <UsePageTracking/>


<Helmet>
  <title>Pune to Nashik Trimbakeshwar Cabs | Taxi & Car Rental – Morya Cab</title>
  <meta
    name="description"
    content="Hire Pune to Nashik Trimbakeshwar cabs with Morya Cab. Clean AC cars, verified drivers & best pricing. Choose Sedan, SUV, Innova Crysta or Tempo Traveller for safe and comfortable travel."
  />
  <meta
    name="keywords"
    content="Pune to Trimbakeshwar cab, Pune to Nashik cab, Pune to Trimbakeshwar taxi, Pune to Nashik car rental, Pune to Trimbakeshwar Innova cab, Pune to Nashik SUV cab, Pune to Trimbakeshwar outstation cab, Pune to Trimbakeshwar pilgrimage taxi, Pune airport to Trimbakeshwar cab, Morya Cab Pune to Nashik Trimbakeshwar"
  />
  <link rel="canonical" href="https://moryacab.com/pune-to-nashik-trimbakeshwar-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune to Nashik Trimbakeshwar Cabs | Taxi & Car Rental – Morya Cab" />
  <meta property="og:description" content="Book Pune to Nashik Trimbakeshwar taxi service with Morya Cab. Enjoy affordable fares with Sedan, SUV, Innova Crysta & Tempo Traveller options for your pilgrimage or family trip." />
  <meta property="og:url" content="https://moryacab.com/pune-to-nashik-trimbakeshwar-cabs" />
  <meta property="og:image" content="https://moryacab.com/assets/images/pune-to-nashik-trimbakeshwar-cabs.jpg" />
  <meta name="twitter:card" content="summary_large_image" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/98.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetonashiktrimbkeshwercabs;